<template>
  <div>
    <the-nav-bar :title="$t('global.settings')" />
    <div class="field-wrapper">
      <div class="field" v-for="(list, i) in routerLinkList" :key="i">
        <div
          class="field-item row-justify-center"
          v-for="(item, j) in list"
          :key="`${i}-${j}`"
          @click="linkTo(item)"
        >
          <svg class="field-item-icon">
            <use :xlink:href="item.icon" />
          </svg>
          <div class="field-item-text">{{ item.text }}</div>

          <svg class="field-item-tag" v-if="item.tag">
            <use :xlink:href="item.tag" />
          </svg>
          <md-icon name="arrow-right"></md-icon>
        </div>
      </div>
    </div>

    <md-popup v-model="isShowPopup" position="bottom">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="$t('common.lang')"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="scroll-view">
        <div
          class="scroll-item row-center"
          v-for="(item, index) in langList"
          :key="`lang-${index}`"
          :class="{ active: currentLangIndex == index }"
          @click="switchLang(index)"
        >
          {{ item.text }}
        </div>
      </md-scroll-view>
    </md-popup>

  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { mapState } from 'vuex';
import { Icon, Popup, PopupTitleBar, ScrollView, Dialog } from 'mand-mobile';
import moment from 'moment';
export default {
  components: {
    TheNavBar,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
  },
  data() {
    return {
      isShowPopup: false,
      langList: [
        {
          text: 'English',
          value: 'en',
          main: 'en',
        },
        {
          text: '中文',
          value: 'zh-cn',
          main: 'zh',
        },
      ],
      currentLangIndex: 0,
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
      routerLinkList() {
        return [
          [
            {
              icon: '#icon-global-earth',
              text: this.$t('common.lang'),
              handler: this.showPopup,
            },
            {
              icon: '#icon-global-faq',
              text: this.$t('mine.faq'),
              handler: this.goFaq,
            },
            {
              icon: '#icon-global-cs',
              text: this.$t('mine.customerService'),
              handler: this.showService,
              href:
              'https://mixin.one/codes/255b9c54-b64e-4095-a789-b66506604461',
            }, 
          ],
          [
            {
              icon: '#icon-global-agreement',
              text: this.$t('mine.userAgreement'),
              hrefObj: {
                'zh-cn': 'https://help.tigaex.com/en/service-terms.html',
                en: 'https://help.tigaex.com/en/service-terms.html',
              },
            },
            {
              icon: '#icon-global-privacy',
              text: this.$t('mine.privacyPolicy'),
              hrefObj: {
                'zh-cn': 'https://help.tigaex.com/en/privacy-policy.html',
                en: 'https://help.tigaex.com/en/privacy-policy.html',
              },
            },
            {
              icon: '#icon-global-about',
              text: this.$t('mine.about'),
              hrefObj: {
                'zh-cn': 'https://help.tigaex.com/zh',
                en: 'https://help.tigaex.com/en',
              },
            },
          ],
        ];
      },
    }),
  },
  created() {
    if (this.isLogin) {
      this.$store.dispatch('updateUserInfo').catch(() => {});
    }
    const lang = this.$root.$i18n.locale;
    this.currentLangIndex = this.langList.findIndex(item => {
      return item.value == lang;
    });
  },
  methods: {
    showPopup() {
      this.isShowPopup = true;
    },
    hidePopup() {
      this.isShowPopup = false;
    },
    switchLang(index) {
      if (index !== this.currentLangIndex) {
        const lang = this.langList[index].value;
        const main = this.langList[index].main;
        this.$root.$i18n.locale = lang;
        this.$root.countries.registerLocale(
          require(`i18n-iso-countries/langs/${main}.json`),
        );
        this.currentLangIndex = index;
        this.$store.commit('setUserInfo', { lang: lang, langMain: main });
        this.$store.commit('setNavLang', { lang: lang, langMain: main });
      }
      this.isShowPopup = false;
    },
    linkTo(item) {
      if (item.path) {
        return this.$router.push(item.path);
      }
      if (item.href) {
        return window.open(item.href, '_blank', 'noopener');
      }
      if (item.hrefObj) {
        return window.open(
          item.hrefObj[this.navLang],
          '_blank',
          'noopeener',
        );
      }
      if (typeof item.handler === 'function') {
        item.handler.call(item);
      }
    },
    showService() {
      Dialog.alert({
        icon: 'icon-smile',
        iconSvg: true,
        title: this.$t('orderDetail.assistance'),
        confirmText: this.$t('common.sendMessage'),
        onConfirm: () => {
          // 打开 local 机器人
          window.location.href = 'mixin://users/1906a44a-d9eb-4d22-b4c7-b46a85969d5c';
        },
      });
    },
    goFaq() {
      this.$router.push('/faq');
    },
    onLogInClick() {
      this.$router.push('/login');
    },

    showHelp(type) {
      let title = '';
      let icon = 'warn';
      let iconSvg = false;
      switch (type) {
        case 'kyc':
          icon = 'icon-verified';
          iconSvg = true;
          title = this.$t('mine.what_is_kyc');
          break;
        case 'blueTrust':
          icon = 'icon-certified-colorful';
          iconSvg = true;
          title = this.$t('mine.what_is_blue_trust');
          break;
      }
      Dialog.alert({
        icon: icon,
        iconSvg: iconSvg,
        content: title,
        confirmText: this.$t('common.known'),
      });
    },
    formatTime(unix) {
      return moment(unix).format('YYYY/MM/DD');
    },
  },
};
</script>

<style lang="stylus" scoped>

.field-wrapper {
  padding: 4.8vw 0 40vw;
  border-top: 2.13vw solid #F8FBFC;

  .field + .field {
    border-top: 2.13vw solid #F8FBFC;
  }

  .field-item {
    flex-row-justify();
    height: 17.07vw;
    padding: 0 4.8vw;

    .field-item-icon {
      icon-size(5.18vw);
    }

    .field-item-text {
      flex: 1;
      padding: 0 4.8vw;
      font-size: 3.73vw;
    }

    .field-item-tag {
      icon-size(6.4vw);
      margin-right: 4.8vw;
    }
  }

}

.title-bar {
border-bottom: 0.27vw solid #eaf1f3;
}

.scroll-view {
  background: #fff;
  padding-bottom: 10vw;
  height: auto;
  min-height: 60vw;
  max-height: 80vw;
  overflow-y: auto;
}

.scroll-item {
  font-size: 4.27vw;
  height: 12.8vw;

  &.active {
    color: color-primary;
  }
}
</style>